module.exports = __webpack_public_path__ + "img/BRCA3_CD4Tconv.cf938d90.png";